import request from '@/utils/request'

export function selectItemList () {
  return request({
    url: '/api/videosort',
    method: 'get'
  })
}

export function bannerList () {
  return request({
    url: '/api/adinfo/BANNER/' + localStorage.getItem('bannerType'),
    method: 'get'
  })
}
export function bannerTags () {
  return request({
    url: '/api/adsort',
    method: 'get'
  })
}
export function videoList () {
  return request({
    url: '/api/videoindex',
    method: 'get'
  })
}

export function videoRecommand () {
  return request({
    url: '/api/videorecommand',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/API/home.js